import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import products, { productsSaga } from './products';
import product, { productSaga } from './product';
import productPrices, { productPricesSaga } from './prices';
import productsPrice, { productsPriceSaga } from './productsPrice';

const productModule = combineReducers({
  products,
  product,
  productPrices,
  productsPrice,
});

export function* productModuleSaga() {
  yield all([productsSaga(), productSaga(), productPricesSaga(), productsPriceSaga()]);
}

export default productModule;
